<script>
export default {
    name: 'Section',
};
</script>

<template>
    <div class="document-section container">
        <h2><slot name="title" /></h2>
        <slot />
    </div>
</template>

<style
    scoped
    lang="scss"
>

</style>
